import React from 'react'

import VoucherValidateErrorModal from '../voucher-validate-error'
import { VOUCHER_VALIDATE_FOR_SIGNUP } from '../../../constants'

const VoucherValidateErrorModalForSignup = () => {
  return <VoucherValidateErrorModal type={VOUCHER_VALIDATE_FOR_SIGNUP} />
}

export default VoucherValidateErrorModalForSignup
